import { render, staticRenderFns } from "./stalls.vue?vue&type=template&id=fec49d50&scoped=true"
import script from "./stalls.vue?vue&type=script&lang=js"
export * from "./stalls.vue?vue&type=script&lang=js"
import style0 from "./stalls.vue?vue&type=style&index=0&id=fec49d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec49d50",
  null
  
)

export default component.exports